import {Option} from 'platform/components';

import {map} from 'ramda';

import {metadaApi} from '@dms/api/base';

import {
  PostTireOrderApiResponse,
  PostTireOrderApiArg,
  GetTireOrderApiResponse,
  GetTireOrderApiArg,
  GetTireOptionsApiResponse,
  GetTireOptionsApiArg,
  GetTireManufacturerApiResponse,
  GetEmployeeMechanicsByBranchApiResponse,
  GetEmployeeMechanicsByBranchApiArg,
  EmployeeMechanicOption,
  PostTireSetApiResponse,
  PostTireSetApiArg,
  PostTiresArchiveApiResponse,
  PostTiresArchiveApiArg,
  PostTireSetDeliveryNoteApiResponse,
  PostTireSetDeliveryNoteApiArg,
  PostTireSetLabelApiResponse,
  PostTireSetLabelApiArg,
  PostTiresTransferToOrderApiResponse,
  PostTiresTransferToOrderApiArg,
  GetTireSetApiResponse,
  GetTireSetApiArg,
  PatchTireSetApiResponse,
  PatchTireSetApiArg,
  PostTireSetAddWheelsApiResponse,
  PostTireSetAddWheelsApiArg,
  PostTiresReceiptApiResponse,
  PostTiresReceiptApiArg,
  PostTiresIssueApiResponse,
  PostTiresIssueApiArg,
  PostTiresRestoreApiResponse,
  PostTiresRestoreApiArg,
  GetCodelistTireLocationApiResponse,
  GetTiresGeneralSettingsApiArg,
  GetTiresGeneralSettingsApiResponse,
  PutTiresGeneralSettingsApiArg,
  PutTiresGeneralSettingsApiResponse,
  PostTireManufacturerApiResponse,
  PostTireManufacturerApiArg,
  PatchTireManufacturerApiResponse,
  PatchTireManufacturerApiArg,
  PatchTireManufacturerSetActiveApiResponse,
  PatchTireManufacturerSetActiveApiArg,
  PatchTireManufacturerSetDefaultApiResponse,
  PatchTireManufacturerSetDefaultApiArg,
  PatchTireManufacturerSetInactiveApiResponse,
  PatchTireManufacturerSetInactiveApiArg,
  PostTireLocationApiResponse,
  PostTireLocationApiArg,
  PatchTireLocationApiResponse,
  PatchTireLocationApiArg,
  PatchTireLocationPositionDownApiResponse,
  PatchTireLocationPositionDownApiArg,
  PatchTireLocationPositionUpApiResponse,
  PatchTireLocationPositionUpApiArg,
  PatchTireLocationSetActiveApiResponse,
  PatchTireLocationSetActiveApiArg,
  PatchTireLocationSetInactiveApiResponse,
  PatchTireLocationSetInactiveApiArg,
  GetTireVehicleCountApiResponse,
  GetTireVehicleCountApiArg,
  GetTireSetCountApiResponse,
  GetTireSetCountApiArg,
  GetOrderSetDefaultContactPersonApiArg,
  GetOrderSetDefaultContactPersonApiResponse,
  GetTireIdsOrdersApiApiResponse,
  GetTireIdsOrdersApiApiArg,
  GetTireWarehousesApiArg,
  GetTireWarehousesApiResponse,
  PostWarehouseEnablingSetAsDisallowApiResponse,
  PostWarehouseEnablingSetAsAllowApiArg,
  GetTireWarehouseApiArg,
  GetTireWarehouseApiResponse,
  PostWarehouseEnablingSetAsDisallowApiArg,
  PostTireWarehouseApiArg,
  PostTireWarehouseApiResponse,
  DeleteTireWarehouseApiArg,
  DeleteTireWarehouseApiResponse,
  PatchTireWarehouseApiArg,
  PatchTireWarehouseApiResponse,
  PostWarehouseEnablingSetAsAllowApiResponse,
  GetTireWarehouseSettingsApiResponse,
  GetTireWarehouseSettingsApiArg,
  GetDefaultStoreUntilByOrderIdApiResponse,
  GetDefaultStoreUntilByOrderIdApiArg,
  DeleteGeneralSettingApiArg,
  DeleteGeneralSettingApiResponse,
  GetGeneralSettingApiArg,
  GetGeneralSettingApiResponse,
  PatchGeneralSettingApiArg,
  PatchGeneralSettingApiResponse,
  PostGeneralSettingApiArg,
  PostGeneralSettingApiResponse,
  GetTireSetLocationResponse,
  GetTireSetLocationArg,
  UpdateTireSetLocationResponse,
  UpdateTireSetLocationArg,
  DeleteTireSetLocationResponse,
  DeleteTireSetLocationArg,
  PostTireSetRequestApiResponse,
  PostTireSetRequestApiArg,
  GetTireSetActionsApiArg,
  GetTireSetActionsApiResponse,
  PostTireSetCancelRequestApiArg,
  PostTireSetCancelRequestApiResponse,
  PatchTireSetRequestApiResponse,
  PatchTireSetRequestApiArg,
  GetTireSetRequestApiResponse,
  GetTireSetRequestApiArg,
  GetTireSetDestinationBranchApiResponse,
  GetTireSetDestinationBranchApiArg,
  GetTireOrderDestinationBranchApiResponse,
  GetTireOrderDestinationBranchApiArg,
  GetTireAspectRatiosApiResponse,
  GetTireAspectRatiosApiArg,
  PostTireAspectRatioApiResponse,
  PostTireAspectRatioApiArg,
  GetTireAspectRatioApiResponse,
  GetTireAspectRatioApiArg,
  DeleteTireAspectRatioApiResponse,
  DeleteTireAspectRatioApiArg,
  PatchTireAspectRatioApiResponse,
  PatchTireAspectRatioApiArg,
  PostTireAspectRatioSetActiveApiResponse,
  PostTireAspectRatioSetActiveApiArg,
  PostTireAspectRatioSetInactiveApiResponse,
  PostTireAspectRatioSetInactiveApiArg,
  PatchTireCategoryApiResponse,
  PatchTireCategoryApiArg,
  DeleteTireCategoryApiResponse,
  DeleteTireCategoryApiArg,
  GetTireCategoryApiResponse,
  GetTireCategoryApiArg,
  PostTireCategoryApiArg,
  PostTireCategoryApiResponse,
  PostTireCategorySetInactiveApiArg,
  PostTireCategorySetDefaultApiArg,
  PostTireCategorySetDefaultApiResponse,
  PostTireCategorySetActiveApiArg,
  PostTireLoadIndexApiResponse,
  PostTireLoadIndexApiArg,
  GetTireLoadIndexApiResponse,
  GetTireLoadIndexApiArg,
  DeleteTireLoadIndexApiResponse,
  DeleteTireLoadIndexApiArg,
  GetTireLoadIndexesApiArg,
  GetTireLoadIndexesApiResponse,
  PostTireLoadIndexSetActiveApiResponse,
  PostTireLoadIndexSetActiveApiArg,
  PostTireLoadIndexSetInactiveApiResponse,
  PostTireLoadIndexSetInactiveApiArg,
  GetTireRimsApiArg,
  GetTireRimsApiResponse,
  PostTireRimApiResponse,
  PostTireRimApiArg,
  GetTireRimApiArg,
  GetTireRimApiResponse,
  DeleteTireRimApiArg,
  DeleteTireRimApiResponse,
  PatchTireRimApiArg,
  PatchTireRimApiResponse,
  PostTireRimSetActiveApiResponse,
  PostTireRimSetActiveApiArg,
  PostTireRimSetInactiveApiResponse,
  PostTireRimSetInactiveApiArg,
  GetTireSpeedRatiosApiArg,
  GetTireSpeedRatiosApiResponse,
  PostTireSpeedRatioApiResponse,
  PostTireSpeedRatioApiArg,
  GetTireSpeedRatioApiArg,
  GetTireSpeedRatioApiResponse,
  PostTireCategorySetActiveApiResponse,
  PostTireCategorySetInactiveApiResponse,
  PostTireSpeedRatioSetActiveApiResponse,
  PostTireSpeedRatioSetActiveApiArg,
  PostTireSpeedRatioSetInactiveApiResponse,
  PostTireSpeedRatioSetInactiveApiArg,
  GetTireWidthsApiArg,
  GetTireWidthsApiResponse,
  PostTireWidthApiResponse,
  PostTireWidthApiArg,
  GetTireWidthApiArg,
  GetTireWidthApiResponse,
  DeleteTireWidthApiArg,
  DeleteTireWidthApiResponse,
  PostTireWidthSetActiveApiResponse,
  PostTireWidthSetActiveApiArg,
  PostTireWidthSetInactiveApiArg,
  PostTireWidthSetInactiveApiResponse,
  PatchTireWidthApiResponse,
  PatchTireWidthApiArg,
  PatchTireSpeedRatioApiArg,
  DeleteTireSpeedRatioApiResponse,
  DeleteTireSpeedRatioApiArg,
  PatchTireSpeedRatioApiResponse,
  PatchTireLoadIndexApiArg,
  PatchTireLoadIndexApiResponse,
  GetTireCategoriesApiArg,
  GetTireCategoriesApiResponse,
  PostTireSetsSetUnreadyApiResponse,
  PostTireSetsSetReadyApiArg,
  PostTireSetsSetReadyApiResponse,
  PostTireSetsSetUnreadyApiArg,
  PostTireSetsCancelRequestApiArg,
  PostTireSetsCancelRequestApiResponse,
  PostTireSetsCancelTransitApiArg,
  PostTireSetsCancelTransitApiResponse,
  PatchTireManufacturerUnsetDefaultApiResponse,
  PatchTireManufacturerUnsetDefaultApiArg,
  TireOrderArchiveResponse,
  TireOrderArchiveApiArg,
  TireOrderRestoreResponse,
  TireOrderRestoreApiArg,
  TireOrderDeleteResponse,
  TireOrderDeleteApiArg,
  GetTireOrderActionsApiArg,
  GetTireOrderActionsApiResponse,
  PutTireOrderAuthorizationProfileResponse,
  PutTireOrderAuthorizationProfileApiArg,
  TireSetsSetRequestTransitResponse,
  TireSetsSetRequestTransitApiArg,
  TireSetsSetTransitAcceptanceResponse,
  TireSetsSetTransitAcceptanceApiArg,
  TireSetsSetCancelTransitApiArg,
  TireSetsSetCancelTransitResponse,
  PostTiresIssueBulkResponse,
  PostTiresIssueBulkApiArg,
  PostTireSetActionsApiResponse,
  PostTireSetActionsApiArg,
  PostTireTransitApiResponse,
  PostTireTransitApiArg,
  GetTireTransitApiResponse,
  GetTireTransitApiArg,
  PatchTireTransitApiResponse,
  PatchTireTransitApiArg,
  DeleteTireTransitApiResponse,
  DeleteTireTransitApiArg,
  PostTireSetsSetReplacementApiResponse,
  PostTireSetsSetReplacementApiArg,
  PostTireSetsUnsetReplacementApiResponse,
  PostTireSetsUnsetReplacementApiArg,
  PostTireCategoryUnsetDefaultApiResponse,
  PostTireCategoryUnsetDefaultApiArg,
  GetTireConditionsApiResponse,
  GetTireConditionApiResponse,
  GetTireConditionApiArg,
  PostTireConditionApiResponse,
  PostTireConditionApiArg,
  PatchTireConditionApiResponse,
  PatchTireConditionApiArg,
  DeleteTireConditionApiResponse,
  DeleteTireConditionApiArg,
  PostTireConditionSetActiveApiResponse,
  PostTireConditionSetActiveApiArg,
  PostTireConditionSetInactiveApiResponse,
  PostTireConditionSetInactiveApiArg,
  PostTireConditionSetDefaultApiResponse,
  PostTireConditionSetDefaultApiArg,
  PostTireConditionUnsetDefaultApiResponse,
  PostTireConditionUnsetDefaultApiArg,
} from './types';

export const metadaTiresApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postTireOrder: build.mutation<PostTireOrderApiResponse, PostTireOrderApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'tireIds', id: `${queryArg.body.customerId}-${queryArg.body.vehicleId}`},
      ],
    }),
    getTireIds: build.query<GetTireIdsOrdersApiApiResponse, GetTireIdsOrdersApiApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order`,
        params: {
          customerId: queryArg.customerId,
          vehicleId: queryArg.vehicleId,
        },
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireIds', id: `${queryArg.customerId}-${queryArg.vehicleId}`},
      ],
    }),
    getTireOrder: build.query<GetTireOrderApiResponse, GetTireOrderApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'tireOrder', id: queryArg.orderId}],
    }),
    getTireOptions: build.query<Option[], GetTireOptionsApiArg>({
      query: (queryArg) => ({
        url: `/core/v1/codelist`,
        params: {category: queryArg.category},
      }),
      transformResponse: (response: GetTireOptionsApiResponse) =>
        map((item) => ({label: item?.name ?? '', value: item?.code ?? ''}), response ?? []),
    }),
    getTireLocations: build.query<GetCodelistTireLocationApiResponse, void>({
      query: () => ({
        url: `/core/v1/codelist/tire-location`,
      }),
      providesTags: ['tireLocations'],
    }),
    getTireManufacturer: build.query<GetTireManufacturerApiResponse, unknown>({
      query: () => ({
        url: `/core/v1/codelist/tire-manufacturer`,
      }),
      providesTags: ['tireManufacturers'],
    }),
    getEmployeeMechanicsByBranch: build.query<
      EmployeeMechanicOption[],
      GetEmployeeMechanicsByBranchApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/employee/mechanics-by-branch`,
        params: {branchId: queryArg.branchId},
      }),
      transformResponse: (response: GetEmployeeMechanicsByBranchApiResponse) =>
        map(
          (item) => ({
            label: item?.name ?? '',
            value: item?.id ?? '',
            isActive: item?.isActive ?? false,
          }),
          response?.employees ?? []
        ),
    }),
    postTireSet: build.mutation<PostTireSetApiResponse, PostTireSetApiArg>({
      query: (queryArg) => ({
        url: `/tires/v8/tire-order/${queryArg.orderId}/tire-set`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (_result, _error, queryArg) => [{type: 'tireOrder', id: queryArg.orderId}],
    }),
    postTiresArchive: build.mutation<PostTiresArchiveApiResponse, PostTiresArchiveApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/archive`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'tireSet', id: queryArg.setId},
        {type: 'tireOrder', id: queryArg.orderId},
        {type: 'tireSetLocation', id: queryArg.setId},
        {type: 'tireSetVehicle'},
        {type: 'tireSetCustomer'},
      ],
    }),
    postTireSetDeliveryNote: build.mutation<
      PostTireSetDeliveryNoteApiResponse,
      PostTireSetDeliveryNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/delivery-note`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    postTireSetLabel: build.mutation<PostTireSetLabelApiResponse, PostTireSetLabelApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/label`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    postTireSetsSetReady: build.mutation<
      PostTireSetsSetReadyApiResponse,
      PostTireSetsSetReadyApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/set-ready`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireSet' as const,
          id: tireSet.tireSetId,
        })),
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireOrder' as const,
          id: tireSet.tireOrderId,
        })),
      ],
    }),
    postTireSetsSetUnready: build.mutation<
      PostTireSetsSetUnreadyApiResponse,
      PostTireSetsSetUnreadyApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/set-unready`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireSet' as const,
          id: tireSet.tireSetId,
        })),
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireOrder' as const,
          id: tireSet.tireOrderId,
        })),
      ],
    }),
    postTiresTransferToOrder: build.mutation<
      PostTiresTransferToOrderApiResponse,
      PostTiresTransferToOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/transfer-to-order/${queryArg.targetOrderId}`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireSet' as const,
          id: tireSet.tireSetId,
        })),
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireOrder' as const,
          id: tireSet.tireOrderId,
        })),
        {type: 'tireOrder', id: queryArg.targetOrderId},
      ],
    }),
    postTireSetsCancelRequest: build.mutation<
      PostTireSetsCancelRequestApiResponse,
      PostTireSetsCancelRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/cancel-request`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireSet' as const,
          id: tireSet.setId,
        })),
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireOrder' as const,
          id: tireSet.orderId,
        })),
      ],
    }),
    postTireSetsCancelTransit: build.mutation<
      PostTireSetsCancelTransitApiResponse,
      PostTireSetsCancelTransitApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/cancel-transit`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireSet' as const,
          id: tireSet.setId,
        })),
        ...queryArg.body.tireSets.map((tireSet) => ({
          type: 'tireOrder' as const,
          id: tireSet.orderId,
        })),
      ],
    }),
    getTireSet: build.query<GetTireSetApiResponse, GetTireSetApiArg>({
      query: (queryArg) => ({
        url: `/tires/v4/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    patchTireSet: build.mutation<PatchTireSetApiResponse, PatchTireSetApiArg>({
      query: (queryArg) => ({
        url: `/tires/v6/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'tireSet', id: queryArg.setId},
        {type: 'tireOrder', id: queryArg.orderId},
      ],
    }),
    postTireSetAddWheels: build.mutation<
      PostTireSetAddWheelsApiResponse,
      PostTireSetAddWheelsApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v2/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/add-wheels`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'tireSet', id: queryArg.setId},
        {type: 'tireOrder', id: queryArg.orderId},
      ],
    }),
    postTiresReceipt: build.mutation<PostTiresReceiptApiResponse, PostTiresReceiptApiArg>({
      query: (queryArg) => ({
        url: `/tires/v2/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/receipt`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    postTiresIssue: build.mutation<PostTiresIssueApiResponse, PostTiresIssueApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/issue`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'tireSet', id: queryArg.setId},
        {type: 'tireSetLocation', id: queryArg.setId},
        {type: 'tireSetVehicle'},
        {type: 'tireSetCustomer'},
      ],
    }),
    postTiresRestore: build.mutation<PostTiresRestoreApiResponse, PostTiresRestoreApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/restore`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'tireSet', id: queryArg.setId},
        {type: 'tireSetVehicle'},
        {type: 'tireSetCustomer'},
      ],
    }),
    getTireSetLocation: build.query<GetTireSetLocationResponse, GetTireSetLocationArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/location`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'tireSetLocation', id: queryArg.setId}],
    }),
    updateTireSetLocation: build.mutation<UpdateTireSetLocationResponse, UpdateTireSetLocationArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/location`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [{type: 'tireSetLocation', id: queryArg.setId}],
    }),
    deleteTireSetLocation: build.mutation<DeleteTireSetLocationResponse, DeleteTireSetLocationArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/location`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'tireSet', id: queryArg.setId},
        {type: 'tireSetLocation', id: queryArg.setId},
      ],
    }),
    getTiresGeneralSettings: build.query<
      GetTiresGeneralSettingsApiResponse,
      GetTiresGeneralSettingsApiArg
    >({
      query: () => ({
        url: `/tires/v1/general-settings`,
      }),
      providesTags: ['tiresInventoryGeneralSettings'],
    }),
    putTiresGeneralSettings: build.mutation<
      PutTiresGeneralSettingsApiResponse,
      PutTiresGeneralSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/general-settings`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: ['tiresInventoryGeneralSettings', 'tiresInventoryDefaultStoreUntil'],
    }),
    postTireManufacturer: build.mutation<
      PostTireManufacturerApiResponse,
      PostTireManufacturerApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-manufacturer`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireManufacturers'],
    }),
    patchTireManufacturer: build.mutation<
      PatchTireManufacturerApiResponse,
      PatchTireManufacturerApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-manufacturer/${queryArg.codelistId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireManufacturers'],
    }),
    patchTireManufacturerSetActive: build.mutation<
      PatchTireManufacturerSetActiveApiResponse,
      PatchTireManufacturerSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-manufacturer/${queryArg.codelistId}/set-active`,
        method: 'PATCH',
      }),
      invalidatesTags: ['tireManufacturers'],
    }),
    patchTireManufacturerSetDefault: build.mutation<
      PatchTireManufacturerSetDefaultApiResponse,
      PatchTireManufacturerSetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-manufacturer/${queryArg.codelistId}/set-default`,
        method: 'PATCH',
      }),
      invalidatesTags: ['tireManufacturers'],
    }),
    patchTireManufacturerSetInactive: build.mutation<
      PatchTireManufacturerSetInactiveApiResponse,
      PatchTireManufacturerSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-manufacturer/${queryArg.codelistId}/set-inactive`,
        method: 'PATCH',
      }),
      invalidatesTags: ['tireManufacturers'],
    }),
    patchTireManufacturerUnsetDefault: build.mutation<
      PatchTireManufacturerUnsetDefaultApiResponse,
      PatchTireManufacturerUnsetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-manufacturer/${queryArg.codelistId}/unset-default`,
        method: 'PATCH',
      }),
      invalidatesTags: ['tireManufacturers'],
    }),
    postTireLocation: build.mutation<PostTireLocationApiResponse, PostTireLocationApiArg>({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-location`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireLocations'],
    }),
    patchTireLocation: build.mutation<PatchTireLocationApiResponse, PatchTireLocationApiArg>({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-location/${queryArg.codelistId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireLocations'],
    }),
    patchTireLocationPositionDown: build.mutation<
      PatchTireLocationPositionDownApiResponse,
      PatchTireLocationPositionDownApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-location/${queryArg.codelistId}/position-down`,
        method: 'PATCH',
      }),
      invalidatesTags: ['tireLocations'],
    }),
    patchTireLocationPositionUp: build.mutation<
      PatchTireLocationPositionUpApiResponse,
      PatchTireLocationPositionUpApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-location/${queryArg.codelistId}/position-up`,
        method: 'PATCH',
      }),
      invalidatesTags: ['tireLocations'],
    }),
    patchTireLocationSetActive: build.mutation<
      PatchTireLocationSetActiveApiResponse,
      PatchTireLocationSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-location/${queryArg.codelistId}/set-active`,
        method: 'PATCH',
      }),
      invalidatesTags: ['tireLocations'],
    }),
    patchTireLocationSetInactive: build.mutation<
      PatchTireLocationSetInactiveApiResponse,
      PatchTireLocationSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/codelist/tire-location/${queryArg.codelistId}/set-inactive`,
        method: 'PATCH',
      }),
      invalidatesTags: ['tireLocations'],
    }),
    getTireVehicleCount: build.query<GetTireVehicleCountApiResponse, GetTireVehicleCountApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-wheel-count`,
        params: {vehicleId: queryArg.vehicleId, customerId: queryArg.customerId},
      }),
    }),
    getTireSetCount: build.query<GetTireSetCountApiResponse, GetTireSetCountApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-set-count`,
        params: {
          vehicleId: queryArg.vehicleId,
          customerId: queryArg.customerId,
          states: queryArg.states,
        },
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireSetVehicle', id: queryArg.vehicleId},
        {type: 'tireSetCustomer', id: queryArg.customerId},
      ],
    }),
    getDefaultStoreUntilByOrderId: build.query<
      GetDefaultStoreUntilByOrderIdApiResponse,
      GetDefaultStoreUntilByOrderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/default-store-until`,
      }),
      providesTags: ['tiresInventoryDefaultStoreUntil'],
    }),
    getOrderSetDefaultContactPerson: build.query<
      GetOrderSetDefaultContactPersonApiResponse,
      GetOrderSetDefaultContactPersonApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v2/tire-order/${queryArg.orderId}/default-contact-person`,
      }),
    }),
    getAllTireWarehouses: build.query<GetTireWarehousesApiResponse, GetTireWarehousesApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/warehouse`,
        params: queryArg?.branchId ? {branchId: queryArg.branchId} : undefined,
      }),
      providesTags: ['tireWarehousesAll'],
    }),
    postTireWarehouse: build.mutation<PostTireWarehouseApiResponse, PostTireWarehouseApiArg>({
      query: (queryArg) => ({
        url: `/tires/v2/warehouse`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireWarehousesAll'],
    }),
    getTireWarehouseSettings: build.query<
      GetTireWarehouseSettingsApiResponse,
      GetTireWarehouseSettingsApiArg
    >({
      query: () => ({
        url: `/tires/v1/warehouse-setting`,
      }),
      providesTags: ['tireWarehouseSettings'],
    }),
    postWarehouseEnablingSetAsAllow: build.mutation<
      PostWarehouseEnablingSetAsAllowApiResponse,
      PostWarehouseEnablingSetAsAllowApiArg
    >({
      query: () => ({
        url: `/tires/v1/warehouse-setting/allow-storage-location`,
        method: 'POST',
      }),
      invalidatesTags: ['tireWarehouseSettings'],
    }),
    postWarehouseEnablingSetAsDisallow: build.mutation<
      PostWarehouseEnablingSetAsDisallowApiResponse,
      PostWarehouseEnablingSetAsDisallowApiArg
    >({
      query: () => ({
        url: `/tires/v1/warehouse-setting/disallow-storage-location`,
        method: 'POST',
      }),
      invalidatesTags: ['tireWarehouseSettings'],
    }),
    getTireWarehouse: build.query<GetTireWarehouseApiResponse, GetTireWarehouseApiArg>({
      query: (queryArg) => ({
        url: `/tires/v2/warehouse/${queryArg.warehouseId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireWarehouse', id: queryArg.warehouseId},
      ],
    }),
    deleteTireWarehouse: build.mutation<DeleteTireWarehouseApiResponse, DeleteTireWarehouseApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/warehouse/${queryArg.warehouseId}`,
        method: 'DELETE',
      }),
    }),
    patchTireWarehouse: build.mutation<PatchTireWarehouseApiResponse, PatchTireWarehouseApiArg>({
      query: (queryArg) => ({
        url: `/tires/v2/warehouse/${queryArg.warehouseId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'tireWarehouse', id: queryArg.warehouseId},
      ],
    }),
    postGeneralSetting: build.mutation<PostGeneralSettingApiResponse, PostGeneralSettingApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/general-setting`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getGeneralSetting: build.query<GetGeneralSettingApiResponse, GetGeneralSettingApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/general-setting/${queryArg.generalSettingId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'generalSettings', id: queryArg.generalSettingId},
      ],
    }),
    deleteGeneralSetting: build.mutation<
      DeleteGeneralSettingApiResponse,
      DeleteGeneralSettingApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/general-setting/${queryArg.generalSettingId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'generalSettings', id: queryArg.generalSettingId},
      ],
    }),
    patchGeneralSetting: build.mutation<PatchGeneralSettingApiResponse, PatchGeneralSettingApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/general-setting/${queryArg.generalSettingId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'generalSettings', id: queryArg.generalSettingId},
      ],
    }),
    postTireSetRequest: build.mutation<PostTireSetRequestApiResponse, PostTireSetRequestApiArg>({
      query: (queryArg) => ({
        url: `/tires/v2/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/request`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    patchTireSetRequest: build.mutation<PatchTireSetRequestApiResponse, PatchTireSetRequestApiArg>({
      query: (queryArg) => ({
        url: `/tires/v3/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/request`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    getTireSetRequest: build.query<GetTireSetRequestApiResponse, GetTireSetRequestApiArg>({
      query: (queryArg) => ({
        url: `/tires/v2/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/request`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    getTireSetDestinationBranch: build.query<
      GetTireSetDestinationBranchApiResponse,
      GetTireSetDestinationBranchApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/destination-branch`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    getTireOrderDestinationBranch: build.query<
      GetTireOrderDestinationBranchApiResponse,
      GetTireOrderDestinationBranchApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/destination-branch`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'tireOrder', id: queryArg.orderId}],
    }),
    postTireSetCancelRequest: build.mutation<
      PostTireSetCancelRequestApiResponse,
      PostTireSetCancelRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/cancel-request`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    getTireSetActions: build.query<GetTireSetActionsApiResponse, GetTireSetActionsApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/actions`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'tireSet', id: queryArg.setId}],
    }),
    postTireSetActions: build.query<PostTireSetActionsApiResponse, PostTireSetActionsApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-order/${queryArg.orderId}/tire-set/${queryArg.setId}/actions`,
        method: 'POST',
        body: queryArg.body,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireSet', id: queryArg.setId},
        {type: 'tireOrder', id: queryArg.orderId},
      ],
    }),
    getTireAspectRatios: build.query<GetTireAspectRatiosApiResponse, GetTireAspectRatiosApiArg>({
      query: () => ({
        url: `/tires/v1/tire-aspect-ratio`,
      }),
      providesTags: ['tireAspectRatios'],
    }),
    postTireAspectRatio: build.mutation<PostTireAspectRatioApiResponse, PostTireAspectRatioApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-aspect-ratio`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireAspectRatios'],
    }),
    getTireAspectRatio: build.query<GetTireAspectRatioApiResponse, GetTireAspectRatioApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-aspect-ratio/${queryArg.tireAspectRatioId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireAspectRatio', id: queryArg.tireAspectRatioId},
      ],
    }),
    deleteTireAspectRatio: build.mutation<
      DeleteTireAspectRatioApiResponse,
      DeleteTireAspectRatioApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-aspect-ratio/${queryArg.tireAspectRatioId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireAspectRatios',
        {type: 'tireAspectRatio', id: queryArg.tireAspectRatioId},
      ],
    }),
    patchTireAspectRatio: build.mutation<
      PatchTireAspectRatioApiResponse,
      PatchTireAspectRatioApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-aspect-ratio/${queryArg.tireAspectRatioId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireAspectRatios',
        {type: 'tireAspectRatio', id: queryArg.tireAspectRatioId},
      ],
    }),
    postTireAspectRatioSetActive: build.mutation<
      PostTireAspectRatioSetActiveApiResponse,
      PostTireAspectRatioSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-aspect-ratio/${queryArg.tireAspectRatioId}/set-active`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireAspectRatios',
        {type: 'tireAspectRatio', id: queryArg.tireAspectRatioId},
      ],
    }),
    postTireAspectRatioSetInactive: build.mutation<
      PostTireAspectRatioSetInactiveApiResponse,
      PostTireAspectRatioSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-aspect-ratio/${queryArg.tireAspectRatioId}/set-inactive`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireAspectRatios',
        {type: 'tireAspectRatio', id: queryArg.tireAspectRatioId},
      ],
    }),
    getTireCategories: build.query<GetTireCategoriesApiResponse, GetTireCategoriesApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category`,
        params: queryArg?.branchId ? {branchId: queryArg.branchId} : undefined,
      }),
      providesTags: ['tireCategories'],
    }),
    getTireConditions: build.query<GetTireConditionsApiResponse, void>({
      query: () => ({
        url: `/tires/v1/tire-condition`,
      }),
      providesTags: ['tireConditions'],
    }),
    getTireCondition: build.query<GetTireConditionApiResponse, GetTireConditionApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-condition/${queryArg.tireConditionId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireCondition', id: queryArg.tireConditionId},
      ],
    }),
    postTireCondition: build.mutation<PostTireConditionApiResponse, PostTireConditionApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-condition`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireConditions'],
    }),
    patchTireCondition: build.mutation<PatchTireConditionApiResponse, PatchTireConditionApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-condition/${queryArg.tireConditionId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireConditions',
        {type: 'tireCondition', id: queryArg.tireConditionId},
      ],
    }),
    deleteTireCondition: build.mutation<DeleteTireConditionApiResponse, DeleteTireConditionApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-condition/${queryArg.tireConditionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireConditions',
        {type: 'tireCondition', id: queryArg.tireConditionId},
      ],
    }),
    postTireConditionSetActive: build.mutation<
      PostTireConditionSetActiveApiResponse,
      PostTireConditionSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-condition/${queryArg.tireConditionId}/set-active`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireConditions',
        {type: 'tireCondition', id: queryArg.tireConditionId},
      ],
    }),
    postTireConditionSetInactive: build.mutation<
      PostTireConditionSetInactiveApiResponse,
      PostTireConditionSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-condition/${queryArg.tireConditionId}/set-inactive`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireConditions',
        {type: 'tireCondition', id: queryArg.tireConditionId},
      ],
    }),
    postTireConditionSetDefault: build.mutation<
      PostTireConditionSetDefaultApiResponse,
      PostTireConditionSetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-condition/${queryArg.tireConditionId}/set-default`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireConditions',
        {type: 'tireCondition', id: queryArg.tireConditionId},
      ],
    }),
    postTireConditionUnsetDefault: build.mutation<
      PostTireConditionUnsetDefaultApiResponse,
      PostTireConditionUnsetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-condition/${queryArg.tireConditionId}/unset-default`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireConditions',
        {type: 'tireCondition', id: queryArg.tireConditionId},
      ],
    }),
    postTireCategory: build.mutation<PostTireCategoryApiResponse, PostTireCategoryApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireCategories'],
    }),
    getTireCategory: build.query<GetTireCategoryApiResponse, GetTireCategoryApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category/${queryArg.tireCategoryId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireCategory', id: queryArg.tireCategoryId},
      ],
    }),
    deleteTireCategory: build.mutation<DeleteTireCategoryApiResponse, DeleteTireCategoryApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category/${queryArg.tireCategoryId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireCategories',
        {type: 'tireCategory', id: queryArg.tireCategoryId},
      ],
    }),
    patchTireCategory: build.mutation<PatchTireCategoryApiResponse, PatchTireCategoryApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category/${queryArg.tireCategoryId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireCategories',
        {type: 'tireCategory', id: queryArg.tireCategoryId},
      ],
    }),
    postTireCategorySetActive: build.mutation<
      PostTireCategorySetActiveApiResponse,
      PostTireCategorySetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category/${queryArg.tireCategoryId}/set-active`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireCategories',
        {type: 'tireCategory', id: queryArg.tireCategoryId},
      ],
    }),
    postTireCategorySetDefault: build.mutation<
      PostTireCategorySetDefaultApiResponse,
      PostTireCategorySetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category/${queryArg.tireCategoryId}/set-default`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireCategories',
        {type: 'tireCategory', id: queryArg.tireCategoryId},
      ],
    }),
    postTireCategoryUnsetDefault: build.mutation<
      PostTireCategoryUnsetDefaultApiResponse,
      PostTireCategoryUnsetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category/${queryArg.tireCategoryId}/unset-default`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireCategories',
        {type: 'tireCategory', id: queryArg.tireCategoryId},
      ],
    }),
    postTireCategorySetInactive: build.mutation<
      PostTireCategorySetInactiveApiResponse,
      PostTireCategorySetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-category/${queryArg.tireCategoryId}/set-inactive`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireCategories',
        {type: 'tireCategory', id: queryArg.tireCategoryId},
      ],
    }),
    getTireLoadIndexes: build.query<GetTireLoadIndexesApiResponse, GetTireLoadIndexesApiArg>({
      query: () => ({
        url: `/tires/v1/tire-load-index`,
      }),
      providesTags: ['tireLoadIndexes'],
    }),
    postTireLoadIndex: build.mutation<PostTireLoadIndexApiResponse, PostTireLoadIndexApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-load-index`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireLoadIndexes'],
    }),
    getTireLoadIndex: build.query<GetTireLoadIndexApiResponse, GetTireLoadIndexApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-load-index/${queryArg.tireLoadIndexId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireLoadIndex', id: queryArg.tireLoadIndexId},
      ],
    }),
    deleteTireLoadIndex: build.mutation<DeleteTireLoadIndexApiResponse, DeleteTireLoadIndexApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-load-index/${queryArg.tireLoadIndexId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireLoadIndexes',
        {type: 'tireLoadIndex', id: queryArg.tireLoadIndexId},
      ],
    }),
    patchTireLoadIndex: build.mutation<PatchTireLoadIndexApiResponse, PatchTireLoadIndexApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-load-index/${queryArg.tireLoadIndexId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireLoadIndexes',
        {type: 'tireLoadIndex', id: queryArg.tireLoadIndexId},
      ],
    }),
    postTireLoadIndexSetActive: build.mutation<
      PostTireLoadIndexSetActiveApiResponse,
      PostTireLoadIndexSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-load-index/${queryArg.tireLoadIndexId}/set-active`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireLoadIndexes',
        {type: 'tireLoadIndex', id: queryArg.tireLoadIndexId},
      ],
    }),
    postTireLoadIndexSetInactive: build.mutation<
      PostTireLoadIndexSetInactiveApiResponse,
      PostTireLoadIndexSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-load-index/${queryArg.tireLoadIndexId}/set-inactive`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireLoadIndexes',
        {type: 'tireLoadIndex', id: queryArg.tireLoadIndexId},
      ],
    }),
    getTireRims: build.query<GetTireRimsApiResponse, GetTireRimsApiArg>({
      query: () => ({
        url: `/tires/v1/tire-rim`,
      }),
      providesTags: ['tireRims'],
    }),
    postTireRim: build.mutation<PostTireRimApiResponse, PostTireRimApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-rim`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireRims'],
    }),
    getTireRim: build.query<GetTireRimApiResponse, GetTireRimApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-rim/${queryArg.tireRimId}`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'tireRim', id: queryArg.tireRimId}],
    }),
    deleteTireRim: build.mutation<DeleteTireRimApiResponse, DeleteTireRimApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-rim/${queryArg.tireRimId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireRims',
        {type: 'tireRim', id: queryArg.tireRimId},
      ],
    }),
    patchTireRim: build.mutation<PatchTireRimApiResponse, PatchTireRimApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-rim/${queryArg.tireRimId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireRims',
        {type: 'tireRim', id: queryArg.tireRimId},
      ],
    }),
    postTireRimSetActive: build.mutation<
      PostTireRimSetActiveApiResponse,
      PostTireRimSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-rim/${queryArg.tireRimId}/set-active`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireRims',
        {type: 'tireRim', id: queryArg.tireRimId},
      ],
    }),
    postTireRimSetInactive: build.mutation<
      PostTireRimSetInactiveApiResponse,
      PostTireRimSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-rim/${queryArg.tireRimId}/set-inactive`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireRims',
        {type: 'tireRim', id: queryArg.tireRimId},
      ],
    }),
    getTireSpeedRatios: build.query<GetTireSpeedRatiosApiResponse, GetTireSpeedRatiosApiArg>({
      query: () => ({
        url: `/tires/v1/tire-speed-ratio`,
      }),
      providesTags: ['tireSpeedRatios'],
    }),
    postTireSpeedRatio: build.mutation<PostTireSpeedRatioApiResponse, PostTireSpeedRatioApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-speed-ratio`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireSpeedRatios'],
    }),
    getTireSpeedRatio: build.query<GetTireSpeedRatioApiResponse, GetTireSpeedRatioApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-speed-ratio/${queryArg.tireSpeedRatioId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'tireSpeedRatio', id: queryArg.tireSpeedRatioId},
      ],
    }),
    patchTireSpeedRatio: build.mutation<PatchTireSpeedRatioApiResponse, PatchTireSpeedRatioApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-speed-ratio/${queryArg.tireSpeedRatioId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireSpeedRatios',
        {type: 'tireSpeedRatio', id: queryArg.tireSpeedRatioId},
      ],
    }),
    deleteTireSpeedRatio: build.mutation<
      DeleteTireSpeedRatioApiResponse,
      DeleteTireSpeedRatioApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-speed-ratio/${queryArg.tireSpeedRatioId}/delete`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireSpeedRatios',
        {type: 'tireSpeedRatio', id: queryArg.tireSpeedRatioId},
      ],
    }),
    postTireSpeedRatioSetActive: build.mutation<
      PostTireSpeedRatioSetActiveApiResponse,
      PostTireSpeedRatioSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-speed-ratio/${queryArg.tireSpeedRatioId}/set-active`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireSpeedRatios',
        {type: 'tireSpeedRatio', id: queryArg.tireSpeedRatioId},
      ],
    }),
    postTireSpeedRatioSetInactive: build.mutation<
      PostTireSpeedRatioSetInactiveApiResponse,
      PostTireSpeedRatioSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-speed-ratio/${queryArg.tireSpeedRatioId}/set-inactive`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireSpeedRatios',
        {type: 'tireSpeedRatio', id: queryArg.tireSpeedRatioId},
      ],
    }),
    getTireWidths: build.query<GetTireWidthsApiResponse, GetTireWidthsApiArg>({
      query: () => ({
        url: `/tires/v1/tire-width`,
      }),
      providesTags: ['tireWidths'],
    }),
    postTireWidth: build.mutation<PostTireWidthApiResponse, PostTireWidthApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-width`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['tireWidths'],
    }),
    getTireWidth: build.query<GetTireWidthApiResponse, GetTireWidthApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-width/${queryArg.tireWidthId}`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'tireWidth', id: queryArg.tireWidthId}],
    }),
    deleteTireWidth: build.mutation<DeleteTireWidthApiResponse, DeleteTireWidthApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-width/${queryArg.tireWidthId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireWidths',
        {type: 'tireWidth', id: queryArg.tireWidthId},
      ],
    }),
    patchTireWidth: build.mutation<PatchTireWidthApiResponse, PatchTireWidthApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-width/${queryArg.tireWidthId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireWidths',
        {type: 'tireWidth', id: queryArg.tireWidthId},
      ],
    }),
    postTireWidthSetActive: build.mutation<
      PostTireWidthSetActiveApiResponse,
      PostTireWidthSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-width/${queryArg.tireWidthId}/set-active`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireWidths',
        {type: 'tireWidth', id: queryArg.tireWidthId},
      ],
    }),
    postTireWidthSetInactive: build.mutation<
      PostTireWidthSetInactiveApiResponse,
      PostTireWidthSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-width/${queryArg.tireWidthId}/set-inactive`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        'tireWidths',
        {type: 'tireWidth', id: queryArg.tireWidthId},
      ],
    }),
    postTireOrderArchive: build.mutation<TireOrderArchiveResponse, TireOrderArchiveApiArg>({
      query: ({orderId}) => ({
        url: `/tires/v1/tire-order/${orderId}/action/archive`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, {orderId}) => [{type: 'tireOrder', id: orderId}],
    }),
    postTireOrderRestore: build.mutation<TireOrderRestoreResponse, TireOrderRestoreApiArg>({
      query: ({orderId}) => ({
        url: `/tires/v1/tire-order/${orderId}/action/restore`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, {orderId}) => [{type: 'tireOrder', id: orderId}],
    }),
    postTireOrderDelete: build.mutation<TireOrderDeleteResponse, TireOrderDeleteApiArg>({
      query: ({orderId}) => ({
        url: `/tires/v1/tire-order/${orderId}/action/delete`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, {orderId}) => [{type: 'tireOrder', id: orderId}],
    }),
    getTireOrderActions: build.query<GetTireOrderActionsApiResponse, GetTireOrderActionsApiArg>({
      query: ({orderId}) => ({
        url: `/tires/v1/tire-order/${orderId}/actions`,
      }),
      providesTags: (result, error, {orderId}) => [{type: 'tireOrder', id: orderId}],
    }),
    putTireOrderAuthorizationProfile: build.mutation<
      PutTireOrderAuthorizationProfileResponse,
      PutTireOrderAuthorizationProfileApiArg
    >({
      query: ({orderId, authorizationProfileId}) => ({
        url: `/tires/v1/tire-order/${orderId}/authorization-profile/${authorizationProfileId}`,
        method: 'PUT',
      }),
      invalidatesTags: (_result, _error, {orderId, authorizationProfileId}) => [
        {type: 'tireOrder', id: orderId},
        {type: 'authorizationProfiles', id: authorizationProfileId},
      ],
    }),
    postTireSetsSetRequestTransit: build.mutation<
      TireSetsSetRequestTransitResponse,
      TireSetsSetRequestTransitApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/set-request-transit`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, {body}) => [
        ...body.tireSets.map((tireSet) => ({type: 'tireSet' as const, id: tireSet.setId})),
        ...body.tireSets.map((tireSet) => ({type: 'tireOrder' as const, id: tireSet.orderId})),
      ],
    }),
    postTireSetsSetTransitAcceptance: build.mutation<
      TireSetsSetTransitAcceptanceResponse,
      TireSetsSetTransitAcceptanceApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/transit-acceptance`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, {body}) => [
        ...body.tireSets.map((tireSet) => ({type: 'tireSet' as const, id: tireSet.setId})),
        ...body.tireSets.map((tireSet) => ({type: 'tireOrder' as const, id: tireSet.orderId})),
      ],
    }),
    postTireSetsSetCancelTransit: build.mutation<
      TireSetsSetCancelTransitResponse,
      TireSetsSetCancelTransitApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/cancel-transit`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, {body}) => [
        ...body.tireSets.map((tireSet) => ({type: 'tireSet' as const, id: tireSet.setId})),
        ...body.tireSets.map((tireSet) => ({type: 'tireOrder' as const, id: tireSet.orderId})),
      ],
    }),
    postTiresIssueBulk: build.mutation<PostTiresIssueBulkResponse, PostTiresIssueBulkApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/issue`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, {body}) => [
        ...body.tireSets.map((tireSet) => ({type: 'tireSet' as const, id: tireSet.setId})),
        ...body.tireSets.map((tireSet) => ({type: 'tireOrder' as const, id: tireSet.orderId})),
        ...body.tireSets.map((tireSet) => ({type: 'tireSetLocation' as const, id: tireSet.setId})),
      ],
    }),
    postTireTransit: build.mutation<PostTireTransitApiResponse, PostTireTransitApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/transit-setting`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getTireTransit: build.query<GetTireTransitApiResponse, GetTireTransitApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/transit-setting/${queryArg.transitSettingId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'generalSettings', id: queryArg.transitSettingId},
      ],
    }),
    patchTireTransit: build.mutation<PatchTireTransitApiResponse, PatchTireTransitApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/transit-setting/${queryArg.transitSettingId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'generalSettings', id: queryArg.transitSettingId},
      ],
    }),
    deleteTireTransit: build.mutation<DeleteTireTransitApiResponse, DeleteTireTransitApiArg>({
      query: (queryArg) => ({
        url: `/tires/v1/transit-setting/${queryArg.transitSettingId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'generalSettings', id: queryArg.transitSettingId},
      ],
    }),
    postTireSetsSetReplacement: build.mutation<
      PostTireSetsSetReplacementApiResponse,
      PostTireSetsSetReplacementApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/set-replacement`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, {body}) => [
        ...body.tireSets.map((tireSet) => ({type: 'tireSet' as const, id: tireSet.setId})),
        ...body.tireSets.map((tireSet) => ({type: 'tireOrder' as const, id: tireSet.orderId})),
      ],
    }),
    postTireSetsUnsetReplacement: build.mutation<
      PostTireSetsUnsetReplacementApiResponse,
      PostTireSetsUnsetReplacementApiArg
    >({
      query: (queryArg) => ({
        url: `/tires/v1/tire-sets/unset-replacement`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, {body}) => [
        ...body.tireSets.map((tireSet) => ({type: 'tireSet' as const, id: tireSet.setId})),
        ...body.tireSets.map((tireSet) => ({type: 'tireOrder' as const, id: tireSet.orderId})),
      ],
    }),
  }),
});

export const {
  usePostTireOrderMutation,
  useGetTireOrderQuery,
  useGetTireOptionsQuery,
  useGetTireLocationsQuery,
  useGetTireManufacturerQuery,
  useGetEmployeeMechanicsByBranchQuery,
  usePostTireSetMutation,
  usePostTiresArchiveMutation,
  usePostTireSetDeliveryNoteMutation,
  usePostTireSetLabelMutation,
  usePostTiresTransferToOrderMutation,
  useGetTireSetQuery,
  useLazyGetTireSetQuery,
  usePatchTireSetMutation,
  usePostTireSetAddWheelsMutation,
  usePostTireSetsSetReadyMutation,
  usePostTireSetsSetUnreadyMutation,
  usePostTiresReceiptMutation,
  usePostTiresIssueMutation,
  usePostTiresRestoreMutation,
  useGetTiresGeneralSettingsQuery,
  usePutTiresGeneralSettingsMutation,
  usePostTireManufacturerMutation,
  usePatchTireManufacturerMutation,
  usePatchTireManufacturerSetActiveMutation,
  usePatchTireManufacturerSetDefaultMutation,
  usePostTireCategoryUnsetDefaultMutation,
  usePatchTireManufacturerSetInactiveMutation,
  usePostTireLocationMutation,
  usePatchTireLocationMutation,
  usePatchTireLocationPositionDownMutation,
  usePatchTireLocationPositionUpMutation,
  usePatchTireLocationSetActiveMutation,
  usePatchTireLocationSetInactiveMutation,
  useGetTireVehicleCountQuery,
  useGetTireSetCountQuery,
  useGetOrderSetDefaultContactPersonQuery,
  useGetTireIdsQuery,
  useGetAllTireWarehousesQuery,
  usePostTireWarehouseMutation,
  usePostWarehouseEnablingSetAsAllowMutation,
  usePostWarehouseEnablingSetAsDisallowMutation,
  useGetTireWarehouseQuery,
  useDeleteTireWarehouseMutation,
  usePatchTireWarehouseMutation,
  useGetTireWarehouseSettingsQuery,
  useGetDefaultStoreUntilByOrderIdQuery,
  usePostGeneralSettingMutation,
  useGetGeneralSettingQuery,
  useDeleteGeneralSettingMutation,
  usePatchGeneralSettingMutation,
  useGetTireSetLocationQuery,
  useUpdateTireSetLocationMutation,
  useDeleteTireSetLocationMutation,
  usePostTireSetRequestMutation,
  usePostTireSetCancelRequestMutation,
  usePostTireSetsCancelTransitMutation,
  usePostTireSetsCancelRequestMutation,
  useGetTireSetActionsQuery,
  usePatchTireSetRequestMutation,
  useGetTireSetRequestQuery,
  useGetTireSetDestinationBranchQuery,
  useGetTireOrderDestinationBranchQuery,
  useGetTireAspectRatiosQuery,
  usePostTireAspectRatioMutation,
  useGetTireAspectRatioQuery,
  useDeleteTireAspectRatioMutation,
  usePatchTireAspectRatioMutation,
  usePostTireAspectRatioSetActiveMutation,
  usePostTireAspectRatioSetInactiveMutation,
  usePostTireCategoryMutation,
  useGetTireCategoryQuery,
  useDeleteTireCategoryMutation,
  usePatchTireCategoryMutation,
  usePostTireCategorySetActiveMutation,
  usePostTireCategorySetDefaultMutation,
  usePostTireCategorySetInactiveMutation,
  useGetTireLoadIndexesQuery,
  usePostTireLoadIndexMutation,
  useGetTireLoadIndexQuery,
  useDeleteTireLoadIndexMutation,
  usePatchTireLoadIndexMutation,
  usePostTireLoadIndexSetActiveMutation,
  usePostTireLoadIndexSetInactiveMutation,
  useGetTireRimsQuery,
  usePostTireRimMutation,
  useGetTireRimQuery,
  useDeleteTireRimMutation,
  usePatchTireRimMutation,
  usePostTireRimSetActiveMutation,
  usePostTireRimSetInactiveMutation,
  useGetTireSpeedRatiosQuery,
  usePostTireSpeedRatioMutation,
  useGetTireSpeedRatioQuery,
  usePatchTireSpeedRatioMutation,
  useDeleteTireSpeedRatioMutation,
  usePostTireSpeedRatioSetActiveMutation,
  usePostTireSpeedRatioSetInactiveMutation,
  useGetTireWidthsQuery,
  usePostTireWidthMutation,
  useGetTireWidthQuery,
  useDeleteTireWidthMutation,
  usePatchTireWidthMutation,
  usePostTireWidthSetActiveMutation,
  usePostTireWidthSetInactiveMutation,
  useGetTireCategoriesQuery,
  useGetTireConditionsQuery,
  usePatchTireManufacturerUnsetDefaultMutation,
  usePostTireOrderArchiveMutation,
  usePostTireOrderRestoreMutation,
  usePostTireOrderDeleteMutation,
  useGetTireOrderActionsQuery,
  usePutTireOrderAuthorizationProfileMutation,
  usePostTireSetsSetRequestTransitMutation,
  usePostTireSetsSetTransitAcceptanceMutation,
  usePostTireSetsSetCancelTransitMutation,
  usePostTiresIssueBulkMutation,
  usePostTireSetActionsQuery,
  usePostTireTransitMutation,
  useGetTireTransitQuery,
  usePatchTireTransitMutation,
  useDeleteTireTransitMutation,
  usePostTireSetsSetReplacementMutation,
  usePostTireSetsUnsetReplacementMutation,
  useGetTireConditionQuery,
  usePostTireConditionMutation,
  usePatchTireConditionMutation,
  useDeleteTireConditionMutation,
  usePostTireConditionSetActiveMutation,
  usePostTireConditionSetInactiveMutation,
  usePostTireConditionSetDefaultMutation,
  usePostTireConditionUnsetDefaultMutation,
} = metadaTiresApi;
